export function ConnectLogo({ src, alt }: { src: string; alt: string }) {
  return <img src={src} alt={alt} class="h-16 max-w-36 mx-auto object-contain" />
}
